module.exports = __webpack_public_path__ + "static/media/8.f96ee9f0.jpg";